import React from "react";
import Image from "next/image";
import { Box } from "@mui/material";
import { Typography } from "./wrappers/Typography";
import ThumbDown from "@mui/icons-material/ThumbDown";

interface RankingDisplayProps {
    rank: number;
}

const RankingDisplay: React.FC<RankingDisplayProps> = ({ rank }) => {
    let icon: React.ReactNode;
    let label: string;
    let color: string = "text.primary";

    if (rank >= 99) {
        icon = <Image src="/rank-top-1-percent.svg" alt="Top 1%" width={16} height={16} />;
        label = "ui.rankings.top1Percent";
    } else if (rank >= 95) {
        icon = <Image src="/rank-top-5-percent.svg" alt="Top 5%" width={16} height={16} />;
        label = "ui.rankings.top5Percent";
    } else if (rank >= 60) {
        icon = <Image src="/rank-above-average.svg" alt="Above Average" width={16} height={16} />;
        label = "ui.rankings.aboveAverage";
    } else if (rank >= 40) {
        icon = <Image src="/rank-average.svg" alt="Average" width={16} height={16} />;
        label = "ui.rankings.average";
    } else if (rank >= 10) {
        icon = <Image src="/rank-below-average.svg" alt="Below Average" width={16} height={16} />;
        label = "ui.rankings.belowAverage";
    } else {
        icon = (
            <Box sx={{ display: "flex", color: "error.main" }}>
                <ThumbDown sx={{ fontSize: 20 }} />
                <ThumbDown sx={{ fontSize: 20, marginLeft: "-8px" }} />
            </Box>
        );
        label = "ui.rankings.bottom10Percent";
        color = "error.main";
    }

    return (
        <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", minWidth: 100 }}>
            {icon}
            <Typography tx={label} variant="caption" color={color} sx={{ mt: 0.5 }} />
        </Box>
    );
};

export default RankingDisplay;
